<template>
  <Layout>
    <div class="row">
      <div class="col-md-12">
        <b-card>
          <PageHeader :title="title" :items="items" style="margin-top: -30px"/>
          <div v-if="trainees.length > 0" class="row mb-2">
            <div class="col-sm-6">
              <span class="badge badge-success mr-2">Total Search Data Found: {{ trainees.length }}</span>
            </div>
            <div  class="col-sm-6">
              <button type="button" id="export-table" @click="onexport"  class="btn btn-light float-right" style="margin-bottom:5px">Download Excel</button>
            </div>
          </div>
          <div class="table-responsive" style="overflow-x: auto">
            <table class="table table-centered table-striped" id="titledExcel">
              <thead>
              <tr>
                <th>Sl</th>
                <th>Form No.</th>
                <th>Name</th>
                <th>NID</th>
                <th>Father Name</th>
                <th>Location</th>
                <th>Field Book No.</th>
              </tr>
              </thead>
              <tbody>
              <tr v-for="(trainee, index) in trainees" :key="index">
                <td>{{ index + 1 }}</td>
                <td>{{ trainee.form_no }}</td>
                <td>
                  <router-link :to="{name: 'traineeView',params: { trainee_id: trainee.id }}" tag="a"
                               target="_blank" title="Trainee Details">
                    {{ trainee.name }}
                  </router-link>
                </td>
                <td>{{ trainee.nid }}({{ trainee.id_type }})</td>
                <td>{{ trainee.father_husband_name }}</td>
                <td>
                  Village : {{ trainee.village.desc }} ({{ trainee.village.id }}),
                  Mouza : {{ trainee.mouza.desc }} ({{ trainee.mouza.id }}),
                  Union : {{ trainee.union.desc }} ({{ trainee.union.id }}),
                  Upazila : {{ trainee.upazila.desc }} ({{ trainee.upazila.id }}),
                  District : {{ trainee.district.desc }} ({{ trainee.district.id }})
                </td>
                <td>
                  <span v-for="(field_book, index) in trainee.field_books" :key="index">
                      Field Book No. : {{ field_book.field_book_no }} <br>
                      Village : {{ field_book.village ? field_book.village.desc : '' }}({{ field_book.village ? field_book.village.id : '' }}),
                      Mouza : {{ field_book.mouza ? field_book.mouza.desc : '' }} ({{ field_book.mouza ? field_book.mouza.id : '' }} ),
                      Union : {{ field_book.mouza ? field_book.mouza.union.desc : '' }}({{ field_book.mouza ? field_book.mouza.union.id : '' }}),
                      Upazila : {{ field_book.mouza ? field_book.mouza.union.upazila.desc : '' }}({{ field_book.mouza ? field_book.mouza.union.upazila.id : '' }}),
                      District : {{ field_book.mouza ? field_book.mouza.union.upazila.district.desc : '' }}({{ field_book.mouza ? field_book.mouza.union.upazila.district.id : '' }}) <br>
                  </span>
                </td>
              </tr>
              </tbody>
            </table>
          </div>
          <div v-if="trainees.length === 0" class="loader">Loading...</div>
          <h5 v-if="trainees.length === 0 && flag === true" class="text-center text-secondary">
            No Data Found
          </h5>
        </b-card>
      </div>
    </div>
  </Layout>
</template>

<script>
  import appConfig from "@src/app.config";
  import Layout from "@layouts/main";
  import PageHeader from "@components/page-header";
  import http from "@state/http";
  import XLSX from 'xlsx';

  export default {
    page: {
      title: "Trainee Information",
      meta: [{ name: "description", content: appConfig.description }]
    },
    components: {Layout, PageHeader },
    data() {
      return {
        title: "Trainee Information",
        items: [
          {
            text: "Dashboard",
            href: "/"
          },
          {
            text: "Trainee Information",
            active: true
          }
        ],
        trainees: [],
        flag: false,
      };
    },

    mounted() {
      this.getTrainee();
    },
    methods: {
      getTrainee() {
        http.get("api/trainees/field-book/mismatch/list").then(response => {
          if (!response.error) {
            this.flag = true;
            this.trainees = response.data.trainees;
          }
        });
      },
      onexport(evt) {
        var tbl = document.getElementById('titledExcel');
        var wb = XLSX.utils.table_to_book(tbl);
        XLSX.writeFile(wb, "trainees.xlsx");
      }
    },
  };
</script>
